import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment-timezone";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Grid, TextField, InputAdornment, Button, Stack, Box } from "@mui/material";
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { getEdgeEventsDashBoard, getEdgeEventsFilterDashboard, downloadEdgeEventsTableDashbOard, clearEdgeEventsDownload, getEdgeEventsFilterDashboardTemp } from "../../actions/Users/authenticateEdgeEvents";
import { GET_EDGE_EVENTS_FILTER, GET_EDGE_EVENTS_FILTER_TEMP } from "../../actions/types";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import CustomLoader from "../Loader/CustomLoaders";
import "./EdgeEvents.css"
import filter from "../../asset/image/filter.svg";
import { PER_PAGE_ITEMS, DEFAULT_PAGE_SIZE, NEW_PER_PAGE_ITEMS } from "../../constants/Constants";
import FilterEdgeEventsDialog from "./../FilterEdgeEventsDialog";
import DateRangeTimePicker from "../../vis/react-app/src/components/DateRangeTimePicker";
import { displayToastError } from "../../server/request";
import { ERROR_GET_EDGE_EVENTS, ERROR_GET_EDGE_EVENTS_FILTER } from "../../actions/error_types";
import { convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI } from "../../utils/util";
import { useHistory, useLocation } from "react-router-dom";
import JsonTooltip, { JsonDataTooltip } from "../JSONTooltip/JsonTooltip";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { StyledEngineProvider } from '@mui/material/styles';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import GetApp from "@material-ui/icons/GetApp";
import { Pagination } from "../Pagination";
import TuneIcon from '@mui/icons-material/Tune';
import Download from '../../asset/image/DownloadUsage.svg';
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import DownloadCSV, { clearCsvDownload } from "../DownloadCSV";

const convertToCsv = (data: any[][], userTimezone: string) => {
    const [_columns, ...rows] = data;
    const csvRows: any[] = [];
    rows.forEach(row => {
        csvRows.push([convertDateTimeIntoTimezone(row[0], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), row[9], row[2], row[6], row[3], row[4],  row[5], row[7]])
    })
    let timestamp = 'Timestamp (' + userTimezone + ')'
    return [[timestamp, 'Site Name', 'DID', 'Source', 'Level', 'Module', 'Description', 'Metadata'], ...csvRows]
}

const DEFAULT_PAGE = 0;

const EdgeEventsGlobal = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const MAX_OPEN_DATE = new Date();
    const MORE_FILTERS_TEXT = "Filters";
    const _q = getDecodeURI(location?.search);
    const [searchValue, setSearchValue] = useState<string>(_q.hasOwnProperty("search") && _q.search.trim() !== '' ? _q.search : "");
    const DEFAULT_PAGE = 1;
    const [page, setPage] = useState<number>(_q.hasOwnProperty("page") && '' != _q.page.trim() ? parseInt(_q.page) : DEFAULT_PAGE);
    const [limit, setLimit] = useState<number>(_q.hasOwnProperty("limit") && '' != _q.limit.trim() ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE);
    const { authReducer, errorReducer, getEdgeEventsDashBoard, getEdgeEventsFilterDashboard, selectedVessel, selectedVesselName, downloadEdgeEventsTableDashbOard, clearEdgeEventsDownload, vesselIds, globalEventsLoading, startDate, endDate, downloadAsCSV, getEdgeEventsFilterDashboardTemp} = props;
    const [edgeEventsData, setEdgeEventsData] = useState<any[]>([]);
    const [edgeEventsFitler, setEdgeEventsFilter] = useState({});
    const [edgeEventsFitlerTemp, setEdgeEventsFilterTemp] = useState({});
    const [showLoader, setShowLoader] = useState<Boolean>(false);
    const [loadingText, setLoadingText] = useState<String>("");
    const [showMoreFilterPopup, setMoreFiltersShowPopUP] = useState<Boolean>(false);
    const [moreFiltersButtonText, setMoreFiltersButtonText] = useState<String>(MORE_FILTERS_TEXT);
    const [pages, setPages] = useState<number>(0);
    const [total, setTotal] = useState<number>(0);
    const [fromItem, setFromItem] = useState<number>(0);
    const [toItem, setToItem] = useState<number>(0);
    const [selectedEventFilters, setSelectedEventFilters] = useState({});
    const [parameters, setParameters] = useState<any>({});
    const [isDownload, setIsDownload] = useState(false);
    const ENTER_KEY_CODE = "Enter";
    const searchTimeoutRef = useRef<any>();


    useEffect(() => {
        if(vesselIds.length > 0) {
            let parameters = {
                startTime: startDate?.toISOString(),
                endTime: endDate?.toISOString(),
                locationId: vesselIds && vesselIds.length > 0 ? `${vesselIds.map((item: any) => `'${item.id}'`).join(",")}` : '',
                deviceIdFilter: "",
                moduleFilter: "",
                levelFilter: "",
                sourceFilter: "",
                search: ""
            }
            getEdgeEventsFilterDashboardTemp(parameters);
        }
        else {
            setPage(0);
            setTotal(0);
            setSelectedEventFilters({});
            setEdgeEventsFilter({});
        }
    }, [vesselIds, startDate, endDate]);

    useEffect(() => {
        if(vesselIds.length > 0 && !_.isEmpty(edgeEventsFitlerTemp)) {
            processQueryUrl();
        }
        else {
            setPage(0);
            setTotal(0);
            setSelectedEventFilters({});
            setEdgeEventsFilter({});
        }
    }, [parameters, edgeEventsFitlerTemp]);


    useEffect(() => {
        if (!_.isEmpty(authReducer.getEdgeEvents)) {
            const edgeEvents = authReducer.getEdgeEvents;
            if (edgeEvents) {

                const rows: any[] = edgeEvents?.data?.rows;
                const columns: string[] = edgeEvents?.data?.columns;
                const edgeEventsData: any[] = [];
                for (let i = 0; i < rows?.length; i++) {
                    const row = {};
                    const currentRow = rows[i];
                    columns.forEach((column, index) => {
                        row[column] = currentRow[index];
                    })
                    edgeEventsData.push(row);
                }
                setEdgeEventsData(edgeEventsData);
            }
        }
    }, [authReducer.getEdgeEvents]);


    useEffect(() => {
        if (!_.isEmpty(authReducer.getEdgeEventsFilter)) {
            const edgeEvents = authReducer.getEdgeEventsFilter?.data;
            if (edgeEvents?.hasOwnProperty('filters')) {
                const data = edgeEvents.filters.data;
                if (data.length >= 3) {
                    let filters = {};
                    filters["sources"] = data[3] ? data[3].split(',') : ['No Records'];
                    filters["devices"] = data[0] ? data[0].split(',') : ['No Records'];
                    filters["modules"] = data[1] ? data[1].split(',') : ['No Records'];
                    filters["levels"] = data[2].split(',').filter((el) => el == "SEVERITY_CRITICAL").length > 0 ? data[2].split(',') : data[2] == "" ? ["SEVERITY_CRITICAL"] : [...data[2].split(','), "SEVERITY_CRITICAL"];
                    const totalRecords = Number.parseInt(data[4]);
                    let totalPages = Math.ceil(totalRecords / limit);
                    let fromIndex = (totalRecords > 0) ? (page * limit + 1) : 0;
                    let toIndex = (fromIndex + limit - 1) > totalRecords ? totalRecords : (fromIndex + limit - 1);
                    setTotal(totalRecords);
                    setPages(totalPages);
                    setFromItem(fromIndex);
                    setToItem(toIndex);
                    let rev = new Map(Object.entries(filters).reverse());
                    let reverse = Object.fromEntries(rev);
                    setEdgeEventsFilter(reverse);
                } else {
                    setTotal(0);
                    setPages(0);
                    setFromItem(0);
                    setToItem(0);
                    setEdgeEventsFilter({});
                }
            }
            dispatch({type: GET_EDGE_EVENTS_FILTER, payload: {}})
        }
    }, [authReducer.getEdgeEventsFilter])

    useEffect(() => {
        if (!_.isEmpty(authReducer.getEdgeEventsFilterTemp)) {
            const edgeEvents = authReducer.getEdgeEventsFilterTemp?.data;
            if (edgeEvents?.hasOwnProperty('filters')) {
                const data = edgeEvents.filters.data;
                if (data.length >= 3) {
                    let filters = {};
                    filters["sources"] = data[3] ? data[3].split(',') : ['No Records'];
                    filters["devices"] = data[0] ? data[0].split(',') : ['No Records'];
                    filters["modules"] = data[1] ? data[1].split(',') : ['No Records'];
                    filters["levels"] = data[2].split(',').filter((el) => el == "SEVERITY_CRITICAL").length > 0 ? data[2].split(',') : data[2] == "No Records" ? ["SEVERITY_CRITICAL"] : [...data[2].split(','), "SEVERITY_CRITICAL"];
                    setEdgeEventsFilterTemp(filters);
                    const levelString = authReducer?.getEdgeEventsFilterTemp?.data?.filters?.data?.[2] || '';
                    const levelList = levelString ? levelString.split(',') : ['SEVERITY_CRITICAL'];
                    const params: any = getDecodeURI(location.search);
                    params.filter = JSON.stringify({ levels: ['SEVERITY_CRITICAL',...levelList] });
                    delete params.page;
                    doNavigate(params);
                }
            }
            dispatch({ type: GET_EDGE_EVENTS_FILTER_TEMP, payload: {} })
        }
    }, [authReducer.getEdgeEventsFilterTemp])

    useEffect(() => {
       if(!_.isEmpty(authReducer.downloadEdgeEventsTable) && isDownload) {
        const data = authReducer?.downloadEdgeEventsTable;
        if (data) {
            const rows: any[] = data?.data?.rows;
            const columns: string[] = data?.data?.columns;
            const downloadData:any = [];
            for (let i = 0; i < rows?.length; i++) {
                const row = {};
                const currentRow = rows[i];
                columns.forEach((column, index) => {
                    row[column] = currentRow[index];
                })
                downloadData.push(row);
            }
            const pdfData = downloadData?.map((row, i) => {
                return [
                 row.ts ? moment(row.ts).utc().format(MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : "",
                 row?.sitename ? row.sitename : '',
                 row.device_id ? row.device_id : '',
                 row.level ? row.level : '',
                 row.module ? row.module : '',
                 row.description ? row.description : ''
                ]
             })
             const doc = new jsPDF('l', 'pt', 'a4');
             let now = moment(moment.now());
             doc.text(`Edge Events - ${now.toLocaleString()}`, 10, 30)
             autoTable(doc, {
             head: [["TIMESTAMP","SITENAME", "DID", "LEVEL", "MODULE", "DESCRIPTION"]],
             body: pdfData,
             theme: "striped",
             startY: 50,
             margin: 10,
             headStyles: {
                 fillColor: "#264C86"
             }
             });
             if(pdfData?.length > 0) {
                doc.save(`edge-events-${now.toLocaleString()}.pdf`);
                setIsDownload(false);
                clearEdgeEventsDownload();
            }
        }
       }
    },[authReducer.downloadEdgeEventsTable, isDownload])

    useEffect(() => {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
            if (authReducer.csvDownloadId === 'global-edge-events') {
                DownloadCSV(convertToCsv(authReducer.csvDataDownloded, authReducer.userTimezone)
                    , {
                        formatters: {
                            0: 'ESC-COMMA',
                            1: 'ESC-COMMA',
                            2: 'ESC-COMMA',
                            5: 'ESC-COMMA',
                            6: "ESC-COMMA",
                            7: 'JSON',
                        }
                    }
                );
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [authReducer.csvDataDownloded])

    useEffect(() => {
        if (!_.isEmpty(errorReducer.errorGetEdgeEvents)) {
            displayToastError(errorReducer.errorGetEdgeEvents.description);
            dispatch({ type: ERROR_GET_EDGE_EVENTS, payload: {} })
        }
    }, [errorReducer.errorGetEdgeEvents]);

    useEffect(() => {
        if (!_.isEmpty(errorReducer.errorGetEdgeEventsFitler)) {
            displayToastError(errorReducer.errorGetEdgeEventsFitler.description);
            dispatch({ type: ERROR_GET_EDGE_EVENTS_FILTER, payload: {} })
        }
    }, [errorReducer.errorGetEdgeEventsFitler]);

    const doNavigate = (params) => {
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    }

    const processQueryUrl = () => {
        let _q = getDecodeURI(location?.search);
        const vesselMap: any = [];
        vesselIds?.map((item: any) => {
          let vesselName = item["id"];
          vesselMap.push(vesselName);
        })
        let k4idhere = vesselMap.length > 0 ? `${"'" + vesselMap.join("','") + "'"}` : null;
        let parameters = {
            startTime: startDate?.toISOString(),
            endTime: endDate?.toISOString(), 
            locationId: k4idhere, 
            pageSize: limit, 
            offset: page,
            deviceIdFilter: "",
            moduleFilter: "",
            levelFilter: "",
            sourceFilter: "",
            search: ""
        }
        setSearchValue(_q.search ? _q.search : '');

        let _limit = _q.limit && '' != _q.limit.trim() ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE;
        if (_limit != limit) {
            parameters.pageSize = _limit;
            setLimit(_limit);
        }

        let _page = _q.page && '' != _q.page.trim() ? parseInt(_q.page) : 0;
        if (_page != page) {
            parameters.offset = _page * _limit;
            setPage(_page);
        }        
        let filters : any = {}
        let SEVRITY = 'SEVERITY_CRITICAL'
        if(_q.filter && '' !== _q.filter.trim()){
            filters = JSON.parse(_q.filter);
            parameters.moduleFilter = filters.modules?.length > 0 ? `and module IN (${filters.modules.map(m => `'${m}'`).join()})`: '';
            parameters.deviceIdFilter = filters.devices?.length > 0 ? `and device_id IN (${filters.devices.map(d => `'${d}'`).join()})`: '';
            parameters.levelFilter = filters.levels?.length > 0 ? `and level IN (${filters.levels.map(l => `'${l}'`).join()})`: '';
            parameters.sourceFilter = filters.sources?.length > 0 ? `and source IN (${filters.sources.map(s => `'${s}'`).join()})`: '';
        } else {
            parameters.levelFilter = `and level IN ('${SEVRITY}')`;
        }
        if(Object.keys(filters).length == 0) {
            filters = {
                "levels": [
                    "SEVERITY_CRITICAL"
                ],
                "modules": [],
                "devices": []
            };
        }
 
        setSelectedEventFilters(filters);

        let _startDate = startDate;
        if(_q.startDate && '' !== _q.startDate && _q.startDate > 1) {
            let incominStarDate =  moment(new Date(parseInt(_q.startDate)));
            _startDate = incominStarDate;
            parameters.startTime = incominStarDate.toISOString();
        }

        let _endDate = endDate;
        if(_q.endDate && '' !== _q.endDate && _q.endDate > 1) {
            let incominEndDate = moment(new Date(parseInt(_q.endDate)));
            _endDate = incominEndDate;
            parameters.endTime = incominEndDate.toISOString();
        }

        if(_q.search && _q.search.trim() !== '') {
            parameters.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_q.search}%' OR  b_metadata ILIKE '%${_q.search}%')`
            setSearchValue(_q.search);
        }

        if(!_startDate.isBefore(_endDate)){
            return;
        }
        if (_q.search) {
            parameters.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_q.search}%' OR  b_metadata ILIKE '%${_q.search}%')`
          }
        // setParameters(parameters);
        getEdgeEventsFilterDashboard(parameters);
        getEdgeEventsDashBoard(parameters);
    }

    const searchBoxKeyDown = (event: any) => {
        if (event && event.key === ENTER_KEY_CODE) {
            doSearch(searchValue);
        }
    }

    const doSearch = (value: string) => {
        let params: any = getDecodeURI(location.search);
        value ? params.search = value : delete params.search;
        delete params.page;
        doNavigate(params);
        setParameters(params);
    }

    const handlePerPageChange = (e: any) => {
        let params: any = getDecodeURI(location.search);
        const value = parseInt(e.target.value);
        params.page = 0;
        params.limit = value;
        doNavigate(params);
        setParameters(params);
    }

    const handlePagination = (e: any, value: number) => {
        let params: any = getDecodeURI(location.search);
        params.page = value - 1;
        doNavigate(params);
        setParameters(params);
    }

    const handleStartDatePicker = (_startDate: moment.Moment | null) => {
        if (_startDate == null || !_startDate.isValid() || startDate.isSame(_startDate))
            return;
        setPage(0)
        let params: any = getDecodeURI(location.search);
        params.startDate = _startDate.valueOf();
        params.page = 0;
        doNavigate(params);
        setParameters(params);
    }

    const handleEndDatePicker = (_endDate: moment.Moment | null) => {
        if (_endDate == null || !_endDate.isValid() || endDate.isSame(_endDate))
            return;
        setPage(0)
        let params: any = getDecodeURI(location.search);
        params.page = 0;
        params.endDate = _endDate.valueOf();
        doNavigate(params);
        setParameters(params);
    }

    const onApplyFilter = (selecedEventFilters) => {
        let params: any = getDecodeURI(location.search);
        params.filter = JSON.stringify(selecedEventFilters);
        delete params.page;
        doNavigate(params);
        setParameters(params);
    }

    const handleDownloadReport = () => {
        const vesselMap: any[] = vesselIds?.map((item: any) => item["id"])
        let k4idhere = vesselMap.length > 0 ? `${"'" + vesselMap.join("','") + "'"}` : null;
        const payload = {
            startTime: startDate?.toISOString(),
            endTime: endDate?.toISOString(),
            locationId: k4idhere,
            pageSize: total,
            offset: 0,
            deviceIdFilter: "",
            moduleFilter: "",
            levelFilter: "",
            sourceFilter: "",
            search: ""
        }
        let SEVERITY = 'SEVERITY_CRITICAL';
        if (_q.filter && '' !== _q.filter.trim()) {
            const filters = JSON.parse(_q.filter);
            payload.moduleFilter = filters?.modules?.length > 0 ? `and module IN (${filters?.modules?.map(m => `'${m}'`).join()})` : '';
            payload.deviceIdFilter = filters?.devices?.length > 0 ? `and device_id IN (${filters?.devices?.map(d => `'${d}'`).join()})` : '';
            payload.levelFilter = filters?.levels?.length > 0 ? `and level IN (${filters?.levels?.map(l => `'${l}'`).join()})` : `and level IN ('${SEVERITY}')`;
            payload.sourceFilter = filters?.sources?.length > 0 ? `and source IN (${filters?.sources?.map(s => `'${s}'`).join()})` : '';
        } else {
            payload.levelFilter = `and level IN ('${SEVERITY}')`;
        }
        if (_q.search) {
            payload.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_q.search}%' OR  b_metadata ILIKE '%${_q.search}%')`
        }
        const params: CsvParameters = {
            type: 'QUERY_CH',
            id: 'global-edge-events',
            payload,
            queryName: 'EVENTS_DASHBOARD',
        }
        downloadAsCSV(params);
    }

    const DownloadEventsTable = () => {
        setIsDownload(true);
        const vesselMap: any = [];
        vesselIds?.map((item: any) => {
          let vesselName = item["id"];
          vesselMap.push(vesselName);
        })
        let k4idhere = vesselMap.length > 0 ? `${"'" + vesselMap.join("','") + "'"}` : null;
        let payload = {
            startTime: startDate?.toISOString(),
            endTime: endDate?.toISOString(), 
            locationId: k4idhere, 
            pageSize: total, 
            offset: page,
            deviceIdFilter: "",
            moduleFilter: "",
            levelFilter: "",
            search: ""
        }
        let SEVERITY = 'SEVERITY_CRITICAL';
        let filters : any = {}
        if(_q.filter && '' !== _q.filter.trim()){
            filters = JSON.parse(_q.filter);
            payload.moduleFilter = filters.modules.length > 0 ? `and module IN (${filters.modules.map(m => `'${m}'`).join()})`: '';
            payload.deviceIdFilter = filters.devices.length > 0 ? `and device_id IN (${filters.devices.map(d => `'${d}'`).join()})`: '';
            payload.levelFilter = filters.levels.length > 0 ? `and level IN (${filters.levels.map(l => `'${l}'`).join()})`: `and level IN ('${SEVERITY}')`
        } else {
            payload.levelFilter = `and level IN ('${SEVERITY}')`;
        }
        if (_q.search) {
            payload.search = `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${_q.search}%' OR  b_metadata ILIKE '%${_q.search}%')`
        }
        
        total > 0 && downloadEdgeEventsTableDashbOard({...payload, offset:0, pageSize:total});
    }
    let inputDateFormat = "YYYY-MM-DD HH:mm:ss.SSSSSS Z UTC";
    
    const handleOnSearchClick = () => {
        doSearch(searchValue);
    }

    const handleOnSearchClear = () => {
        setSearchValue('');
        doSearch('');
      }

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchValue(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            doSearch(e.target.value);
        }, 1000)
    }

    return (
        <Fragment><StyledEngineProvider injectFirst>
            <Grid container className="container-edgeEvent edgeEventsPadding" padding={3}>
                <Grid container item xs={12} sm={12} md={12} lg={12} className="topbarWidth alignTopbarItemsCenter">
                <Grid item xs={3} sm={3} md={3} lg={3} className="searchbarMaxWidth1">
                        <Box className="searchbarBox">
                        {<TextField
                            id="outlined-basic"
                            variant="outlined"
                            placeholder="Type something"
                            size="small"
                            autoComplete="off"
                            value={searchValue}
                            onChange={handleOnSearchChange}
                            onKeyDown={(event) => searchBoxKeyDown(event)}
                            InputLabelProps={{ className: "serachLabel" }}
                            InputProps={{
                                className: "searchbarInputs",
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {!searchValue && <SearchIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClick}
                                        />}
                                        {searchValue && <CloseIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClear}
                                        />}
                                    </InputAdornment>
                                    ),
                                }}
                            />}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={1} className="eventsFilterPadding filterButtonMaxWidth">
                        <Button variant="outlined" startIcon={<TuneIcon id="filterIcon"/>} onClick={() => setMoreFiltersShowPopUP(true)} id="filterButton">
                            Filter
                        </Button>
                    </Grid>
                    {total !== 0 && <Grid item style={{ marginLeft: "auto" }}>
                        <div className="download-summary-btn" onClick={() => handleDownloadReport()}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>
                    </Grid>}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Box>
                        <Pagination
                            rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                            count={total ? total : 0}
                            rowsPerPage={limit}
                            page={page + 1}
                            onPageChange={handlePagination}
                            onRowsPerPageChange={handlePerPageChange}
                        />
                    </Box>
                    <TableContainer className="alertsTable-FleetDashboard">
                        <Table aria-label="simple table">
                            <TableHead className="tableHead alertsTable-tableHead">
                            <TableRow className="alertReports-tableRow">
                                <TableCell className="alertsTable-fleetDataTable font-wt-900">TIMESTAMP</TableCell>
                                <TableCell className="alertsTable-fleetDataTable font-wt-900">SITE NAME</TableCell>
                                <TableCell className="alertsTable-fleetDataTable font-wt-900">DID</TableCell>
                                <TableCell className="alertsTable-fleetDataTable font-wt-900">SOURCE</TableCell>
                                <TableCell className="alertsTable-fleetDataTable font-wt-900">LEVEL</TableCell>
                                <TableCell className="alertsTable-fleetDataTable font-wt-900">MODULE</TableCell>
                                <TableCell align="left" className="alertsTable-fleetDataTable font-wt-900 width-20">DESCRIPTION</TableCell>
                                <TableCell className="alertsTable-fleetDataTable font-wt-900">METADATA</TableCell>
                            </TableRow>
                            </TableHead>
                            { vesselIds.length !== 0 && edgeEventsData.length > 0 &&
                            <TableBody className="tableBody alertsTable-tableBody">
                                {
                                edgeEventsData.length > 0 && edgeEventsData.map((row) =>
                                    <TableRow className="alertsData-tabelRow">
                                    <TableCell className="alertsTable-tableCell">
                                    {convertDateTimeIntoTimezone(row['ts'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}
                                    </TableCell>
                                    <Tooltip title={<span style={{ fontSize: "12px" }}>{row['sitename']}</span>}>
                                        <TableCell className="alertsTable-tableCell">
                                    {row['sitename']}
                                    </TableCell>
                                    </Tooltip>
                                    <TableCell className="alertsTable-tableCell">
                                    {row['device_id']}
                                    </TableCell>
                                    <TableCell className="alertsTable-tableCell alertsTable-tableCell-source">{row['source']}</TableCell>
                                    <TableCell className="alertsTable-tableCell">{row['level']}</TableCell>
                                    <TableCell className="alertsTable-tableCell">{row['module']}</TableCell>
                                    <Tooltip title={<span style={{ fontSize: "12px" }}>{row['description']}</span>}>
                                        <TableCell className="events-description-width">{row['description']}</TableCell>
                                    </Tooltip>
                                    <TableCell className="alertsTable-tableCell labelDetails">
                                    <JsonDataTooltip data={row['metadata']} />
                                    </TableCell>
                                    </TableRow>
                                )
                                }
                            </TableBody> }
                            {(vesselIds.length === 0 || edgeEventsData.length === 0) && <TableBody>
                                <TableRow>
                                    <TableCell colSpan={12} className="noDataAvailableCss" align="center">No data available</TableCell>
                                </TableRow>
                            </TableBody>}
                            
                        </Table>
                     </TableContainer>
                </Grid>
              
            </Grid>
            <FilterEdgeEventsDialog open={showMoreFilterPopup} edgeEventsFitler={edgeEventsFitler} onClose={() => { setMoreFiltersShowPopUP(false) }} onApplyFilter={onApplyFilter} selectedEventFilters={selectedEventFilters} globalEvents={true}></FilterEdgeEventsDialog>
        </StyledEngineProvider></Fragment>);
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    startDate: state?.authReducer?.newSummaryStartDate,
    endDate: state?.authReducer?.newSummaryEndDate,
});

export default withRouter(
    connect(mapStateToProps, {
        getEdgeEventsDashBoard,
        getEdgeEventsFilterDashboard,
        downloadEdgeEventsTableDashbOard,
        downloadAsCSV,
        clearEdgeEventsDownload,
        getEdgeEventsFilterDashboardTemp
    })(EdgeEventsGlobal)
);